import React, { useEffect, useState } from "react";
import { MessageSquareText, ChevronDown, ChevronUp } from "lucide-react";
import { guestQuestionsApi } from "../../lib/checkinApi";
import { GuestQuestionCard } from "../admin/mail/GuestQuestionCard";

// /checkin: pending guest questions (Booking + site) answerable from the phone.
export function GuestQuestionsWidget() {
  const [qs, setQs] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(true);

  const load = () => Promise.all([guestQuestionsApi.list(), guestQuestionsApi.faq()]).then(([a, b]) => { setQs(a); setFaqs(b); }).catch(() => setQs([]));
  useEffect(() => { load(); const t = setInterval(load, 120000); return () => clearInterval(t); }, []);

  if (!qs || qs.length === 0) return null;
  return (
    <section className="rounded-2xl border-2 border-[#C48B31] bg-[#fff8ec] overflow-hidden" data-testid="checkin-guest-questions">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 px-4 py-3 text-left" data-testid="checkin-guest-questions-toggle">
        <MessageSquareText className="h-5 w-5 text-[#C48B31]" />
        <span className="font-bold text-[#2b1410]">Domande ospiti da rispondere</span>
        <span className="rounded-full bg-[#C48B31] text-white text-xs font-bold px-2 py-0.5" data-testid="checkin-guest-questions-count">{qs.length}</span>
        <span className="flex-1" />
        {open ? <ChevronUp className="h-5 w-5 text-[#7c5a4e]" /> : <ChevronDown className="h-5 w-5 text-[#7c5a4e]" />}
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-3">
          {qs.map((q) => <GuestQuestionCard key={q.id} q={q} faqs={faqs} onDone={load} api={guestQuestionsApi} />)}
        </div>
      )}
    </section>
  );
}
